import React from 'react';
import { graphql } from 'gatsby';
import { FormattedMessage, useIntl } from 'react-intl';
import { handleRipple } from '../../../../helpers/ripple';
import {
  StyledSection,
  StyledContentBlock,
  ImageSection,
  Image,
  ContentSection,
  Title,
  Text,
  Button,
  Orangecircle,
} from './styled';

const Verse = () => {
  const { formatMessage } = useIntl();

  return (
    <StyledSection>
      <StyledContentBlock>
        <ImageSection>
          <Image
            src={formatMessage({ id: 'home.spendrewards.verse.image.src' })}
            alt={formatMessage({ id: 'home.spendrewards.verse.image.alt' })}
            loading="lazy"
          />
        </ImageSection>
        <ContentSection>
          <Title>
            <FormattedMessage id="home.spendrewards.verse.title" />
          </Title>
          <Text>
            <FormattedMessage id="home.spendrewards.verse.text" />
          </Text>
          <Button
            href={formatMessage({
              id: 'home.spendrewards.verse.buttonLink',
            })}
            target="_blank"
            onMouseEnter={handleRipple}
          >
            <FormattedMessage id="home.spendrewards.verse.buttonText" />
            <Orangecircle src="/images/uploads/Icon.svg" alt="Orange Icon" />
          </Button>
        </ContentSection>
      </StyledContentBlock>
    </StyledSection>
  );
};

export const VerseFragment = graphql`
  fragment Verse on Json {
    spendrewards {
      verse {
        image {
          src
          alt
        }
        title
        text
        buttonText
        buttonLink
      }
    }
  }
`;

export default Verse;
